import { serializeSrt, type Caption } from '@remotion/captions';

const MAX_CHARS = 42;
const MAX_GAP_MS = 700;

/**
 * Whisper returns one Caption per word. An .srt with one cue per word is
 * unusable, so group words into readable lines — breaking on length, on a
 * pause, or on sentence-ending punctuation.
 */
export const groupIntoLines = (captions: Caption[]): Caption[][] => {
  const lines: Caption[][] = [];
  let current: Caption[] = [];
  let chars = 0;

  for (let i = 0; i < captions.length; i++) {
    const c = captions[i];
    const prev = captions[i - 1];
    const gap = prev ? c.startMs - prev.endMs : 0;

    if (current.length > 0 && (chars + c.text.length > MAX_CHARS || gap > MAX_GAP_MS)) {
      lines.push(current);
      current = [];
      chars = 0;
    }

    current.push(c);
    chars += c.text.length;

    if (/[.!?]$/.test(c.text.trim())) {
      lines.push(current);
      current = [];
      chars = 0;
    }
  }

  if (current.length > 0) lines.push(current);
  return lines;
};

export const captionsToSrt = (captions: Caption[]): string =>
  serializeSrt({ lines: groupIntoLines(captions) });


